import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { number } from 'prop-types';
import cloneDeep from 'lodash/cloneDeep';

import PreviewBodyRow from './PreviewBodyRow';
import AutocodeSelectionAction from '../../autocode/AutocodeSelectionBox/AutocodeSelectionActions';
import { useACSelectionBoxContext } from '../../autocode/ACContext/ACSelectionBoxContext';
import { checkAndAddFunctionInAutocodeNode } from '../../autocode/AutocodeFunctions';
import {
  fetchDictionaryDetails,
  removeTargetRow,
} from '../../../actions/deActions/deBuildActions';
import { divideJointExpressions } from '../../../util/autocodeUtils';
import { getSampleWeighted } from '../../../actions/autocodeActions';
import DeDialog from '../shared/DeDialog';
import CantCompleteEditDilogContent from './CantCompleteEditDilogContent';
import UpdateEditDilogContent from './UpdateEditDilogContent';
import { createDataSmartSearch } from '../../../util/CrosstabUtils';

const PreviewBody = ({ failedTarget }) => {
  const dispatch = useDispatch();
  const {
    deBuildTargets,
    studies,
    userData,
    datahubWeightTypes,
    tempTarget,
  } = useSelector(state => ({
    tempTarget: state.deBuild.tempTarget,
    deBuildTargets: state.deBuild.deBuildTargets,
    studies: state.deImportDefiniton.studies,
    userData: state.login.loginResponse.data,
    datahubWeightTypes: state.study.datahubWeightTypes,
  }));

  const [isUpdateTargetPopup, setUpdateTargetPopupState] = React.useState(
    false
  );
  const [selectedTarget, setSelectedTareget] = React.useState(null);
  const [
    isCantUpdateTargetPopup,
    setCantUpdateTargetPopupState,
  ] = React.useState(false);

  const acSelContext = useACSelectionBoxContext();
  const { insertNodes } = AutocodeSelectionAction(
    acSelContext.state,
    acSelContext.dispatch
  );

  const _handleCloseCantCompletePopup = () => {
    setCantUpdateTargetPopupState(false);
    setSelectedTareget(false);
  };
  const _handleCloseUpdateTargetPopup = () => {
    setUpdateTargetPopupState(false);
    setSelectedTareget(false);
  };

  const _updateExpressionToSelectionBox = (target, rowIndex) => {
    const tg = target.dataSmartSearch.autocodenode;
    insertNodes([checkAndAddFunctionInAutocodeNode(cloneDeep(tg))], '0', -1);
    dispatch(removeTargetRow(rowIndex - 1));
    if (selectedTarget) {
      _handleCloseUpdateTargetPopup();
    }
  };

  const _handleEditExpression = async (target, rowIndex) => {
    const targetPN = target.pn;
    const targetWT = target.wt;
    if (
      targetPN === studies.activeStudy.pn &&
      datahubWeightTypes.wt === targetWT
    ) {
      _updateExpressionToSelectionBox(target, rowIndex);
    } else {
      const uid = userData.userId;
      const accountId = userData.currentAccountId;
      const productNo = studies.activeStudy.pn;
      const weightType = datahubWeightTypes.wt;
      const divisor = datahubWeightTypes.dv;
      const expressionList = divideJointExpressions([target.ex]);

      const sampleWeightedData = await getSampleWeighted(
        uid,
        accountId,
        productNo,
        weightType,
        divisor,
        expressionList
      );
      if (sampleWeightedData) {
        const isInValidDataPoint = sampleWeightedData.includes(null);
        if (isInValidDataPoint) {
          setCantUpdateTargetPopupState(true);
        } else {
          setUpdateTargetPopupState(true);
          setSelectedTareget({ target, rowIndex });
        }
      }
    }
  };

  const _updateSelectionBox = DictionaryDetails => {
    if (Object.keys(DictionaryDetails.TargetGrid).length > 0) {
      const dataSmartSearch = createDataSmartSearch(
        {},
        DictionaryDetails,
        tempTarget.expr,
        tempTarget.name,
        'TargetGrid'
      );

      dataSmartSearch.autocodenode.labelOverride = tempTarget.name;
      dataSmartSearch.autocodenode.useLabelOverride = true;
      insertNodes(
        [
          checkAndAddFunctionInAutocodeNode(
            cloneDeep(dataSmartSearch.autocodenode)
          ),
        ],
        '0',
        -1
      );
      // TODO: to celar selected target 
      // Clear target state when moving from left navigation. 
      // dispatch(setTempSelectedTargetForBuild(null));
    }
  };

  const _setEditTarget = async () => {
    const uid = userData.userId;
    const accountId = userData.currentAccountId;
    const dictionaryDetails = await fetchDictionaryDetails(
      uid,
      accountId,
      tempTarget
    );
    const data = {
      TargetGrid: dictionaryDetails,
    };
    _updateSelectionBox(data);
  };

  const _handleUpdateTarget = () => {
    const { rowIndex, target } = selectedTarget;
    _updateExpressionToSelectionBox(target, rowIndex);
  };

  React.useEffect(() => {
    if (tempTarget) {
      _setEditTarget();
    }
  }, [tempTarget]);

  if (deBuildTargets.length === 0) {
    return (
      <div className="de--build--preview-bodyrow">
        <div className="de--build--preview-notarget">Add Targets</div>
      </div>
    );
  }
  let bodyClass = 'de--build--preview-bodycol';
  if (failedTarget > 0) {
    bodyClass += 'warning';
  }
  return (
    <div className="de--build--preview-bodyrow">
      <div className={bodyClass}>
        {deBuildTargets.map((row, index) => (
          <PreviewBodyRow
            target={row}
            rowIndex={index + 1}
            key={row.actualLabel + row.ct}
            handleEditExpression={_handleEditExpression}
          />
        ))}
      </div>
      {isCantUpdateTargetPopup && (
        <DeDialog
          className="de--build-edit-expression--modal"
          open={isCantUpdateTargetPopup}
          title="Can't complete edit request"
          id="cantCompleteEdit"
          onClose={_handleCloseCantCompletePopup}
        >
          <CantCompleteEditDilogContent
            onClose={_handleCloseCantCompletePopup}
          />
        </DeDialog>
      )}
      {isUpdateTargetPopup && (
        <DeDialog
          className="de--build-edit-expression--modal"
          open={isUpdateTargetPopup}
          title="Update target"
          id="updateTargetExp"
        >
          <UpdateEditDilogContent
            onClose={_handleCloseUpdateTargetPopup}
            updateTarget={_handleUpdateTarget}
          />
        </DeDialog>
      )}
    </div>
  );
};

PreviewBody.propTypes = {
  failedTarget: number,
};

export default PreviewBody;
